import type * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[16px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        primary: "border-[#5C88C5] bg-[#C4DDFF] text-[#1F1F1F]",
        // secondary: "border-transparent bg-[#f97316] text-white",
        success: "border-[#00C41D] bg-[#D8FFDE] text-[#1F1F1F]",
        danger: "border-[#FF152C] bg-[#FFD5D9] text-[#1F1F1F]",
        warning: "border-[#FFFB15] bg-[#FEFFD8] text-[#1F1F1F]",
        // neutral: "border-transparent bg-[#737373] text-white",
        // outline: "border-[#7c6df2] text-[#7c6df2] bg-transparent",
        // ghost: "border-transparent bg-[#f0f4ff] text-[#7c6df2]",
      },
      size: {
        sm: "px-2 py-0.5",
        md: "px-[8px] py-[10px] w-[120px] h-[38px]",
        lg: "px-3 py-1",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
  dot?: boolean;
}

function Badge({
  className,
  variant,
  size,
  icon,
  dot,
  children,
  ...props
}: BadgeProps) {
  return (
    <div
      className={`text-[#1F1F1F] font-medium justify-center items-center ${cn(
        badgeVariants({ variant, size }),
        className
      )}`}
      {...props}
    >
      {dot && <div className="w-1.5 h-1.5 rounded-full bg-current" />}
      {icon && icon}
      {children}
    </div>
  );
}

export { Badge, badgeVariants };
